export default __webpack_public_path__ + "static/media/26.32f643b6.png";